module.exports = __webpack_public_path__ + "static/media/starship.0d960105.svg";